import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { ICity } from "../../models/BaseModel";
import { confirmDialog } from "primereact/confirmdialog";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ImageGalleryDialog } from "./Gallery";
import LocationAutocomplete, { NominatimResponse } from "../../shared/LocationAutoCompleteGM";
import { SpotVideo } from "./SpotVideo";

interface IImage {
    id: number;
    imageFileName: string;
    isCoverPhoto?: boolean;
    order?: number;
}

interface ICitySpot {
    id?: number;
    title: string;
    description?: string;
    imageIds?: number[];
    isActive?: boolean
    latitude?: number
    longitude?: number
}

const emptyCitySpot: ICitySpot = {
    title: "",
    description: "",
    imageIds: [],
};

interface IProps {
    visible: boolean;
    onHide: () => void;
    images: IImage[];
    roomId?: number;
    toast: any;
    reloadImages: () => void;
    title?: string;
    hotel: ICity;
}

const schema = yup.object({
    title: yup.string().required("Title is required"),
    // description: yup.string().required("Description is required"),
});

export const CitySpot = (props: IProps) => {
    const [localImages, setLocalImages] = useState<IImage[]>([]);
    const [selectedImageIds, setSelectedImageIds] = useState<number[]>([]);
    const [submitting, setSubmitting] = useState(false);
    const [spots, setSpots] = useState<ICitySpot[]>([]);
    const [openAddSpots, setOpenAddSpots] = useState(false);
    const [selectedSpots, setSelectedSpots] = useState<ICitySpot[]>([]);
    const [viewImages, setViewImages] = useState<IImage[]>([]);
    const [viewVisible, setViewVisible] = useState(false);
    const [editingSpotId, setEditingSpotId] = useState<number | null>(null);
    const [openselectImages, setOpenselectImages] = useState<{ open: boolean; Id?: number; }>({ open: false, Id: undefined });
    const [description, setDescription] = useState("");
    const [imageDialog, setImageDialog] = useState<{
        open: boolean;
        images: { id: number; imageFileName: string }[];
        title?: string;
        Id?: number;
    }>({ open: false, images: [], title: '', Id: undefined });

    const [spotVideo, setSpotVideo] = useState<{
        open: boolean;
        video: { id: number; videoFileName: string }[];
        title?: string;
        Id?: number;
    }>({ open: false, video: [], title: '', Id: undefined });

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<ICitySpot>({
        resolver: yupResolver(schema),
        shouldFocusError: false,
    });

    const lat = watch('latitude');
    const lng = watch('longitude');

    const handleImageSelect = (id: number) => {
        setSelectedImageIds((prev) =>
            prev.includes(id)
                ? prev.filter((i) => i !== id)
                : [...prev, id]
        );
    };

    const showRoomImages = async (rowData: any) => {
        const response = await Fetch(`City/GetCityImages?cityId=${rowData.id}`, "GET", null, null, props.toast);
        if (response) {
            const images: { imageFileName: string; id: number }[] = await response.json();
            setImageDialog({ open: true, images, title: rowData.title, Id: rowData.id });
        }
    };

    const showSpotsVideo = async (rowData: any) => {
        const response = await Fetch(`City/GetSpotVideo?spotId=${rowData.id}`, "GET", null, null, props.toast);
        if (response) {
            const video: { videoFileName: string; id: number }[] = await response.json();
            setSpotVideo({ open: true, video, title: rowData.title, Id: rowData.id });
        }
    };

    const loadSpots = async () => {
        const response = await Fetch(`City/GetSpots/${props.hotel.id}`, "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            if (data) setSpots(data);
        }
    };

    const loadImages = async () => {
        const response = await Fetch(`City/GetCityImages?cityId=${props.hotel.id}`, "GET", null, null, props.toast);
        if (response) {
            const data: { imageFileName: string; id: number }[] = await response.json();
            setLocalImages(data);
        }
    };

    const onSubmit = async (data: ICitySpot) => {
        if (description === "" || description === null) {
            return props.toast.current?.show({ severity: 'error', detail: "Description field is required", life: 3000 });
        }
        data.description = description
        setSubmitting(true);
        const payload = {
            id: editingSpotId,
            cityId: props.hotel.id,
            title: data.title,
            description: data.description,
            latitude: data.latitude,
            longitude: data.longitude,
            imageIds: selectedImageIds,
        };
        const url = editingSpotId ? "City/UpdateSpot" : "City/AddSpot";
        const response = await Fetch(url, "POST", payload, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", summary: editingSpotId ? "Spot Updated" : "Spot Added", detail: editingSpotId ? "City spot updated successfully" : "City spot added successfully", life: 3000, });
            reset(emptyCitySpot);
            setSelectedImageIds([]);
            setEditingSpotId(null);
            setOpenAddSpots(false);
            loadSpots();
        }
        setSubmitting(false);
    };



    const handleDeleteSpot = async (id: number) => {
        const response = await Fetch(`City/DeleteSpot/${id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", detail: "Spot deleted successfully", life: 3000, });
            loadSpots();
        }
    };

    const onHide1 = () => {
        setOpenAddSpots(false);
        setOpenselectImages({ open: false, Id: 0 });
    };

    const openNew = () => {
        reset(emptyCitySpot);
        setSelectedImageIds([]);
        setEditingSpotId(null);
        setOpenAddSpots(true);
        setDescription("")
    };

    // const imageTemplate = (spot: ICitySpot) => {
    //     const imgs = (spot.imageIds || []).map((id) => localImages.find((i) => i.id === id)).filter(Boolean) as IImage[];

    //     return (
    //         <div className="flex flex-wrap gap-2">
    //             {imgs.slice(0, 3).map((img) => (
    //                 <img key={img.id} src={`${baseUrl}city/streamImage?fileName=${img.imageFileName}`}
    //                     alt=""
    //                     style={{ width: 50, height: 40, borderRadius: "6px", objectFit: "cover", }}
    //                 />
    //             ))}
    //             {imgs.length > 3 && <span>+{imgs.length - 3} more</span>}
    //         </div>
    //     );
    // };

    const rejectFunc = () => { }

    const confirmDelete = (rowData: ICitySpot) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.title}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => handleDeleteSpot(rowData.id!),
            reject: () => rejectFunc()
        });
    }

    const actionTemplate = (spot: ICitySpot) => (
        <div className="flex justify-content-center gap-2">
            {/* <Button icon="pi pi-eye" className="p-button-text p-button-info" tooltip="View Images" onClick={() => {
                const imgs = (spot.imageIds || []).map((id) => localImages.find((i) => i.id === id))
                    .filter(Boolean) as IImage[];
                setViewImages(imgs);
                setViewVisible(true);
            }}
            /> */}
            <Button icon="pi pi-pencil" className="p-button-text p-button-success" tooltip="Edit Spot" onClick={() => { reset(spot); setDescription(spot.description || ""); setSelectedImageIds(spot.imageIds || []); setEditingSpotId(spot.id!); setOpenAddSpots(true); }} />
            {/* <Button icon="pi pi-plus" className="p-button-text p-button-success" tooltip="Add Images" onClick={() => { reset(spot); setSelectedImageIds(spot.imageIds || []); setOpenselectImages({ open: true, Id: spot.id }); }} /> */}
            <Button icon="pi pi-image" className="p-button-success p-button-text p-0" tooltip="Add Images" onClick={() => showRoomImages(spot)} />
            <Button icon="pi pi-video" className="p-button-success p-button-text p-0" tooltip="Add Video" onClick={() => showSpotsVideo(spot)} />
            <Button icon="pi pi-trash" className="p-button-text p-button-danger" tooltip="Delete Spot" onClick={() => { confirmDelete(spot) }} />

        </div>
    );


    const handleSave = async () => {
        const payload = {
            cityspotId: openselectImages.Id,
            spots: selectedImageIds,
        };

        const response = await Fetch("City/UpdateSpotImages", "POST", payload, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", summary: "Saved", detail: "City spots saved successfully", life: 3000, });
            loadSpots();
        }
    };


    const toggleStatus = async (id: number) => {
        if (!id) return;
        const response = await Fetch(`city/toggleCitySpotsStatus/${id}`, "PUT", null, null, props.toast);
        if (response) {
            loadSpots();
            props.toast.current.show({ severity: "success", summary: "Saved", detail: "Status changed successfully", life: 3000, });
        }
    };


    const statusBody = (rowData: ICitySpot) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.isActive ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isActive ? '#4caf50' : '#f44336' }} />
                <span className="cursor-pointer" onClick={() => rowData.id && toggleStatus(rowData.id)} > {rowData.isActive ? 'Yes' : 'No'}</span>
            </div>
        );
    };

    const descriptionBodyTemplate = (rowData: ICitySpot) => {
        return <div dangerouslySetInnerHTML={{ __html: rowData.description || "" }} />;
    };

    useEffect(() => {
        if (props.hotel.id) {
            loadImages();
            loadSpots();
        }
    }, [props.hotel.id]);

    useEffect(() => {
        setLocalImages([...props.images].sort((a, b) => (a.order ?? 0) - (b.order ?? 0)));
        if (props.visible) loadSpots();
    }, [props.images]);


    const onLocationSelect = (location?: NominatimResponse) => {
        if (location) {
            setValue('latitude', parseFloat(location.lat));
            setValue('longitude', parseFloat(location.lng));
        } else {
            setValue('latitude', undefined);
            setValue('longitude', undefined);
        }
    }

    return (
        <>
            <div style={{ backgroundColor: "#ffffff", border: "1px solid #a0d8a0", borderRadius: "12px", padding: "1rem", margin: "1rem 0", boxShadow: "0 4px 12px rgba(0, 128, 0, 0.1)", }}  >
                <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4"
                    style={{ background: "linear-gradient(90deg, #def7e3ff, #ecf4edff)", borderBottom: "2px solid #95e99c", borderRadius: "8px 8px 0 0", padding: "0.6rem 1rem", boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", }}  >
                    <div className="flex gap-4 w-full">
                        <Button style={{ width: "80px", height: "30px" }} onClick={openNew} label="New" icon="pi pi-plus" type="button" className="p-button-sm p-button-rounded p-button-success mb-2" />
                        <div className="w-full flex align-items-center justify-content-center">
                            <h4 style={{ margin: 0, color: "#00796b" }}>
                                Spots of "{props.hotel.name}"
                            </h4>
                        </div>
                    </div>
                </div>

                {/* --- Table View --- */}
                <div className="border-top-1 mt-4 pt-3 bg-teal-50 border-round-md shadow-1 p-3">
                    {spots.length > 0 ? (
                        <DataTable value={spots} selection={selectedSpots} onSelectionChange={(e) => setSelectedSpots(e.value)} dataKey="id" responsiveLayout="scroll"
                            rowClassName={() => 'bg-teal-50'} className="grey-teal-table" >
                            <Column field="title" header="Title" sortable />
                            <Column field="description" header="Description" body={descriptionBodyTemplate} />
                            <Column field="isActive" header="Active" sortable body={statusBody} />
                            {/* <Column header="Images" body={imageTemplate} /> */}
                            <Column header="Actions" body={actionTemplate} style={{ textAlign: "center", width: "10rem" }} />
                        </DataTable>
                    ) : (
                        <p>No spots added yet</p>
                    )}
                </div>
            </div>

            {/* --- Add/Edit Spot Dialog --- */}
            <Dialog visible={openAddSpots} header="Add / Edit City Spot" style={{ width: "65vw" }} onHide={onHide1}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVInput column={1} required label="Title" control={control} name="title" error={errors.title?.message} />
                    <LocationAutocomplete col="12" label={`City Geographic Coordinates (Lat: ${lat ?? ""} | Lng: ${lng ?? ""})`} onLocationSelect={onLocationSelect} countryCode="in" />
                    {/* <JVInput column={2} required label="Description" control={control} name="description" error={errors.description?.message} /> */}
                    <div className="flex flex-column w-12 ml-2">
                        <label htmlFor="">Description:<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={description} onChange={(event, editor) => { setDescription(editor.getData()); }} />
                    </div>
                    {/* <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-3">
                        <Button style={{ width: "100px" }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded" />
                    </div> */}
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-3">
                        <Button style={{ width: "100px" }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded" />
                        <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide1} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </Dialog>

            {/* --- View Images Dialog --- */}
            <Dialog header="Spot Images" visible={viewVisible} style={{ width: "50vw" }} onHide={() => setViewVisible(false)} >
                <div className="grid">
                    {viewImages.length > 0 ? (
                        viewImages.map((img) => (
                            <div key={img.id} className="col-6 md:col-4 lg:col-3">
                                <Card className="shadow-1 border-round-md">
                                    <img src={`${baseUrl}city/streamImage?fileName=${img.imageFileName}`} alt="" style={{ width: "100%", height: 100, objectFit: "cover", borderRadius: "8px", }} />
                                </Card>
                            </div>
                        ))
                    ) : (
                        <p>No images available</p>
                    )}
                </div>
            </Dialog>

            {/* Select Images For city Images */}
            <Dialog visible={openselectImages.open} header={`Select Images for`} style={{ width: "65vw" }} onHide={onHide1} >
                <div className="col-12 mt-3">
                    <div className="flex flex-wrap gap-3">
                        {localImages.map((img) => (
                            <div key={img.id} className="relative">
                                <img src={`${baseUrl}city/streamImage?fileName=${img.imageFileName}`} alt="" style={{ width: 100, height: 70, objectFit: "cover", borderRadius: "8px", border: selectedImageIds.includes(img.id) ? "3px solid #4caf50" : "1px solid #ddd", cursor: "pointer", }} onClick={() => handleImageSelect(img.id)} />
                                {selectedImageIds.includes(img.id) && (
                                    <i className="pi pi-check-circle text-green-500 absolute" style={{ top: 4, right: 4 }} />
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-3">
                    <Button style={{ width: "100px" }} label="SAVE" type="button" className="p-button-rounded" onClick={handleSave} />
                </div>
            </Dialog>
            <ImageGalleryDialog visible={imageDialog.open} onHide={() => setImageDialog((prev) => ({ ...prev, open: false }))} images={imageDialog.images}
                title={imageDialog.title} roomId={imageDialog.Id ?? 0} toast={props.toast} reloadImages={() => showRoomImages({ id: imageDialog.Id, title: imageDialog.title })} />

            <SpotVideo visible={spotVideo.open} onHide={() => setSpotVideo((prev) => ({ ...prev, open: false }))} video={spotVideo.video}
                title={spotVideo.title} spotId={spotVideo.Id ?? 0} toast={props.toast} reload={() => showSpotsVideo({ id: spotVideo.Id, title: spotVideo.title })} />
        </>
    );
};
